import {
  PanVerificationStandard,
  type PanVerificationStandardProps,
} from './PanVerificationStandard';

// Designer's PanVerificationLite screen. Same PAN input form as Standard —
// the Lite API also requires PAN number + full name (docs.signcare.io pan-lite);
// it's a distinct named screen so the session/builder can map the Lite binding.
export function PanVerificationLite(props: PanVerificationStandardProps) {
  return <PanVerificationStandard {...props} />;
}
